import PropTypes from 'prop-types';
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { innerRings, outerRings } from './paths';

const narrowFadeIn = keyframes`
  0% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
`;

const harshFadeIn = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

function swapColor(props) {
  return keyframes`
    0% {
      fill: ${props.futureColor};
    }
    80% {
      fill: ${props.currentColor};
    }
    100% {
      fill: ${props.currentColor};
    }
  `;
}

const shiftColorAnimation = css`
  animation:
    ${swapColor} ${props => props.animationDuration}ms ease-in-out infinite,
    ${harshFadeIn} ${props => props.animationDuration}ms ease-in-out infinite;
`;

const simpleAnimation = css`
  animation: ${harshFadeIn} ${props => props.animationDuration}ms ease-in-out infinite;
`;

function getAnimationDelay(index, duration, max) {
  const clockwiseIndex = max - index - 1;
  const baseDelay = clockwiseIndex * (duration / max);
  return baseDelay - duration;
}

const Path = styled.path.attrs(props => ({
  style: {
    animationDelay: `${getAnimationDelay(props.index, props.animationDuration, 90)}ms`,
  },
}))`
  /* Looks pretty cool */
  /* animation: ${narrowFadeIn} ${props => (props.index % 10) + 500}ms linear infinite;
  animation-delay: ${props => (props.index % 10) + 50}ms; */

  /* MAGIC */
  /* animation: ${narrowFadeIn} 1800ms ease-in-out infinite;
  animation-delay: ${props => props.index * 20}ms; */

  ${props => (props.shiftColor ? shiftColorAnimation : simpleAnimation)}
`;

const rotate = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;

const rotateReverse = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

const InnerGroup = styled.g`
  animation: ${rotateReverse} 3000ms infinite linear;
  animation-play-state: ${props => (props.playAnimation ? 'playing' : 'paused')};
  transform-origin: 37.9% 50%;
`;

const OuterGroup = styled.g`
  animation: ${rotate} 1500ms infinite linear;
  animation-play-state: ${props => (props.playAnimation ? 'playing' : 'paused')};
  transform-origin: 50% 50%;
`;

function OnomondoLogo({
  primaryColor = 'var(--gray-12)',
  secondaryColor = 'var(--gray-9)',
  futureColor = 'var(--gray-7)',
  duration = 900 * 3,
  size = 355,
  animated = false,
  shiftColor = false,
  playAnimation = false,
}) {
  if (!animated) {
    return (
      <svg
        width={size}
        height={size}
        viewBox='0 0 355 355'
      >
        <g>
          {outerRings.reverse().map((d, idx) => (
            <path
              key={idx}
              fill={primaryColor}
              d={d}
            />
          ))}
          <g>
            {innerRings.reverse().map((d, idx) => (
              <path
                key={idx}
                fill={secondaryColor}
                d={d}
              />
            ))}
          </g>
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 355 355'
    >
      <OuterGroup playAnimation={playAnimation}>
        {outerRings.reverse().map((d, idx) => (
          <Path
            key={idx}
            index={idx}
            animationDuration={duration}
            fill={primaryColor}
            shiftColor={shiftColor}
            currentColor={primaryColor}
            futureColor={futureColor}
            d={d}
          />
        ))}
        <InnerGroup playAnimation={playAnimation}>
          {innerRings.reverse().map((d, idx) => (
            <Path
              key={idx}
              index={idx}
              animationDuration={duration}
              fill={secondaryColor}
              shiftColor={shiftColor}
              currentColor={secondaryColor}
              futureColor={futureColor}
              d={d}
            />
          ))}
        </InnerGroup>
      </OuterGroup>
    </svg>
  );
}

OnomondoLogo.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  futureColor: PropTypes.string,
  duration: PropTypes.number,
  size: PropTypes.number,
  animated: PropTypes.bool,
  shiftColor: PropTypes.bool,
  playAnimation: PropTypes.bool,
};

export default OnomondoLogo;
